import { CSSProperties, ReactElement } from 'react';

import styles from './DetailsSection.module.scss';

export interface IDetailsSectionItem {
  label: string;
  value: string;
}

export interface IDetailsSectionProps {
  title: string;
  items: IDetailsSectionItem[];
}

const DetailsSection = ({ title, items }: IDetailsSectionProps): ReactElement => (
  <div>
    <div className={styles.sectionTitle}>{title}</div>
    <div
      className={styles.sectionGrid}
      style={{ '--columns-count': Math.max(items.length, 1) } as CSSProperties}
    >
      {items.map(item => (
        <div key={item.label} className={styles.sectionItem}>
          <div className={styles.itemLabel}>{item.label}</div>
          <div className={styles.itemValue}>{item.value}</div>
        </div>
      ))}
    </div>
  </div>
);

export default DetailsSection;
